import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setUser, setToken, setIsLoggedIn } from "../features/userSlice";
import { loginUser } from "../services/userService";
import { toast } from "react-toastify";
import Logo from "../assets/logo.jpg";
import themeColors from "../theme/ThemeColors";
import { Eye, EyeOff } from "lucide-react";
export default function Login() {
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();
    // prevent double submit
    if (loading) return;
    // setError(null);
    setLoading(true);

    try {
      const body = { email: email.trim(), password };

      const response = await loginUser(body);

      if (response.status === 200) {
        const { user, token } = response.data;
        // persist token and user (legacy keys kept for existing code paths)
        localStorage.setItem("token", token);
        localStorage.setItem("user", JSON.stringify(user));
        dispatch(setUser(user));
        dispatch(setToken(token));
        dispatch(setIsLoggedIn(true));
        toast.success("Login successful!");
        navigate("/dashboard");
        setLoading(false);
      } else {
        // prefer server-provided message when available
        const serverMessage = response?.data?.message || response?.data?.error;
        const msg = serverMessage || `Login failed (status ${response.status})`;
        console.error("Login failed with status:", response.status, msg);
        toast.error(msg);
        setLoading(false);
      }
    } catch (err) {
      // Extract a useful message from axios error shape if present
      const message =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        err?.message ||
        "Login failed";
      toast.error(message);
      console.error("Login failed:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-sky-100 flex items-center justify-center px-6">
      {/* Card */}
      <div className="w-full max-w-md bg-white/90 backdrop-blur rounded-2xl shadow-xl border border-white/40">
        <div className="p-6 sm:p-8">
          {/* Header */}
          <div className="mb-6 text-center">
            <img src={Logo} alt="Logo" className="w-16 h-16 mx-auto mb-4" />
            <h2
              style={{
                color: themeColors.primary,
              }}
              className="text-2xl font-bold"
            >
              Odisha Parcel Service
            </h2>
            <h1 className="mt-2 text-xl font-semibold text-gray-800">
              Welcome Back 👋
            </h1>
            <p className="mt-1 text-sm text-gray-500">
              Please enter your credentials to sign in
            </p>
          </div>

          {/* Form */}
          <form className="space-y-4" onSubmit={handleSubmit}>
            {/* Email */}
            <div>
              <label className="block mb-1 text-sm font-medium text-gray-700">
                Email
              </label>
              <input
                type="email"
                placeholder="name@company.com"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full rounded-lg border border-gray-300 bg-gray-50 px-3 py-2.5 text-gray-900
                           focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none transition"
              />
            </div>

            {/* Password */}
            <div>
              <label className="block mb-1 text-sm font-medium text-gray-700">
                Password
              </label>

              <div className="relative">
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="••••••••"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full rounded-lg border border-gray-300 bg-gray-50 px-3 py-2.5 pr-10 text-gray-900
                 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none transition"
                />

                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
                >
                  {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
              </div>
            </div>
            {/* Facility */}
            {/* <div>
              <label className="block mb-1 text-sm font-medium text-gray-700">
                Facility
              </label>

              <div className="relative">
                <select
                  required
                  defaultValue=""
                  className="appearance-none w-full rounded-lg border border-gray-300 bg-gray-50 px-3 py-2.5 pr-10
                 text-gray-400
                 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none transition
                 valid:text-gray-900"
                >
                  <option value="" disabled hidden>
                    Select facility
                  </option>
                  <option value="bhubaneswar">Bhubaneswar Hub</option>
                  <option value="cuttack">Cuttack Branch</option>
                  <option value="puri">Puri Branch</option>
                  <option value="rourkela">Rourkela Hub</option>
                </select>

                <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-gray-400">
                  ▼
                </span>
              </div>
            </div> */}

            {/* Remember + Forgot */}
            <div className="flex items-center justify-between pt-1">
              <label className="flex items-center gap-2 text-sm text-gray-600">
                <input
                  type="checkbox"
                  className="w-4 h-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                />
                Remember me
              </label>

              <button
                type="button"
                className="text-sm font-medium text-blue-600 hover:underline"
              >
                Forgot password?
              </button>
            </div>

            {/* Button */}
            <button
              type="submit"
              className="mt-2 w-full rounded-lg bg-gradient-to-r from-blue-600 to-indigo-600 px-5 py-2.5
                         text-sm font-semibold text-white shadow-md hover:shadow-lg hover:opacity-95
                         focus:outline-none focus:ring-4 focus:ring-blue-300 transition"
            >
              {loading ? "Loading..." : "Sign in"}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}
